import * as React from 'react';
import { styled } from './druid/./druid/Utilities';

import { ISliderProps, ISliderStyleProps, ISliderStyles } from '/druid/Slider.types';

import { SliderBase } from '/druid/Slider.base';
import { getStyles } from '/druid/Slider.styles';

export const Slider: React.FunctionComponent<ISliderProps> = styled<ISliderProps, ISliderStyleProps, ISliderStyles>(
  SliderBase,
  getStyles,
  undefined,
  {
    scope: 'Slider',
  },
);
